<template>
	<div class="title-description">
		<h1>{{ title }}</h1>
		<p class="description">{{ description }}</p>
	</div>
</template>

<script>
export default {
	name: 'TitleDescription',
	props: {
		title: String,
		description: String,
	},
};
</script>

<style scoped lang="scss">
h1 {
	@include rem(margin, 0 0 8px 0);
}
.description {
	@include rem('line-height', 25px);
}
</style>
